import { faker } from "@faker-js/faker";

export const createModerator = ({
    id,
    displayName,
    username,
    isManager = false,
    avatarUrl
}) => {
    return {
        id: id || faker.string.numeric(6),
        displayName,
        username,
        isManager,
        avatarUrl,
        isPhotoModerator: true
    };
};
